import './GanttChartLineRenderer.css';
export var svgWrapperCSS = '_mnxak30-3-12-1';